var _path, _path2, _path3, _path4, _circle, _path5, _circle2, _ellipse, _path6, _ellipse2, _circle3, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineUpF1Logo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0032 2.5H9.00317V0H15.0032V2.5Z",
    fill: "#FFBF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2.5H9V0H11V2.5Z",
    fill: "#FFE699"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5885 6.74264L18.7601 3.91421L20.1743 2.5L23.0027 5.32843L21.5885 6.74264Z",
    fill: "#FFBF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8213 4.97487L18.7606 3.91421L20.1748 2.5L21.2355 3.56066L19.8213 4.97487Z",
    fill: "#FFDF80"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0034,
    cy: 14,
    r: 9.99998,
    fill: "#FFBF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.00002C6.47718 4.00002 2.00004 8.47717 2.00004 14L22 14C22 8.47716 17.5229 4.00002 12 4.00002Z",
    fill: "#FFE699"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0034,
    cy: 14,
    r: 7.49999,
    fill: "#F53D3D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.7673,
    cy: 10.0048,
    rx: 0.659721,
    ry: 1.97916,
    transform: "rotate(-46.6672 15.7673 10.0048)",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0034 21.5C16.1455 21.5 19.5034 18.1421 19.5034 14H4.50342C4.50342 18.1421 7.86128 21.5 12.0034 21.5Z",
    fill: "#FA9E9E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.8959,
    cy: 18.7222,
    rx: 0.659721,
    ry: 1.97916,
    transform: "rotate(-90 11.8959 18.7222)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0034,
    cy: 14,
    r: 7.24999,
    stroke: "#610505",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4998 14.6251H11.9998L11.9998 10.2501",
    stroke: "#300303",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineUpF1Logo);
export default __webpack_public_path__ + "static/media/line_up_f1_logo.6826b168d7c089b02d03190036de1c9d.svg";
export { ForwardRef as ReactComponent };